// extracted by mini-css-extract-plugin
export default {"wrapper":"Step10processing_wrapper__V2tB2","list":"Step10processing_list__STWoo","errorTitle":"Step10processing_errorTitle__8xOAh"};